import AnimationElements from './modules/Animation/enterElements'
import AnimationsElements from './modules/Animation/animation'
import './modules/Layouts/menu'

AnimationElements()
AnimationsElements()

document.addEventListener('DOMContentLoaded', function () {
    var dropdowns = document.querySelectorAll('.dropdown-submenu .dropdown-toggle');

    dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener('click', function (e) {
            var submenu = this.nextElementSibling;
            if (submenu.style.display === 'block') {
                submenu.style.display = 'none';
            } else {
                submenu.style.display = 'block';
            }
            e.stopPropagation();
            e.preventDefault();
        });
    });
});
